export default [
  {
    fleet_size_label: '0-1',
    fleet_size_min: 0,
    fleet_size_max: 1,
    bottom_25_percent: 1,
    median: 2,
    top_25_percent: 3,
    bottom_25_percent_base: 0,
    median_base: 0,
    top_25_percent_base: 0,
  },
  {
    fleet_size_label: '2-3',
    fleet_size_min: 2,
    fleet_size_max: 3,
    bottom_25_percent: 0.666666667,
    median: 1.5,
    top_25_percent: 2.5,
    bottom_25_percent_base: 1,
    median_base: 2,
    top_25_percent_base: 3,
  },
  {
    fleet_size_label: '4-6',
    fleet_size_min: 4,
    fleet_size_max: 6,
    bottom_25_percent: 0.6,
    median: 1.25,
    top_25_percent: 2.4,
    bottom_25_percent_base: 2,
    median_base: 4.5,
    top_25_percent_base: 7.5,
  },
  {
    fleet_size_label: '7-8',
    fleet_size_min: 7,
    fleet_size_max: 8,
    bottom_25_percent: 0.571428571,
    median: 1.25,
    top_25_percent: 2.25,
    bottom_25_percent_base: 3.6,
    median_base: 7.5,
    top_25_percent_base: 14.4,
  },
  {
    fleet_size_label: '9-11',
    fleet_size_min: 9,
    fleet_size_max: 11,
    bottom_25_percent: 0.545454545,
    median: 1.2,
    top_25_percent: 2.181818182,
    bottom_25_percent_base: 4.571428571,
    median_base: 10,
    top_25_percent_base: 18,
  },
  {
    fleet_size_label: '12-14',
    fleet_size_min: 12,
    fleet_size_max: 14,
    bottom_25_percent: 0.5,
    median: 1.083333333,
    top_25_percent: 2,
    bottom_25_percent_base: 6,
    median_base: 13.2,
    top_25_percent_base: 24,
  },
  {
    fleet_size_label: '15-17',
    fleet_size_min: 15,
    fleet_size_max: 17,
    bottom_25_percent: 0.470588235,
    median: 1.0625,
    top_25_percent: 1.9375,
    bottom_25_percent_base: 7,
    median_base: 15.16666667,
    top_25_percent_base: 28,
  },
  {
    fleet_size_label: '18-19',
    fleet_size_min: 18,
    fleet_size_max: 19,
    bottom_25_percent: 0.444444444,
    median: 1.055555556,
    top_25_percent: 2,
    bottom_25_percent_base: 8,
    median_base: 18.0625,
    top_25_percent_base: 32.9375,
  },
  {
    fleet_size_label: '20-23',
    fleet_size_min: 20,
    fleet_size_max: 23,
    bottom_25_percent: 0.476190476,
    median: 1.095238095,
    top_25_percent: 2,
    bottom_25_percent_base: 8.444444444,
    median_base: 20.05555556,
    top_25_percent_base: 38,
  },
  {
    fleet_size_label: '24-28',
    fleet_size_min: 24,
    fleet_size_max: 28,
    bottom_25_percent: 0.5,
    median: 1.037037037,
    top_25_percent: 1.875,
    bottom_25_percent_base: 10.95238095,
    median_base: 25.19047619,
    top_25_percent_base: 46,
  },
  {
    fleet_size_label: '29-32',
    fleet_size_min: 29,
    fleet_size_max: 32,
    bottom_25_percent: 0.5,
    median: 1.068965517,
    top_25_percent: 1.838709677,
    bottom_25_percent_base: 14,
    median_base: 29.03703704,
    top_25_percent_base: 52.5,
  },
  {
    fleet_size_label: '33-38',
    fleet_size_min: 33,
    fleet_size_max: 38,
    bottom_25_percent: 0.484848485,
    median: 1.060606061,
    top_25_percent: 1.823529412,
    bottom_25_percent_base: 16,
    median_base: 34.20689655,
    top_25_percent_base: 58.83870968,
  },
  {
    fleet_size_label: '39-44',
    fleet_size_min: 39,
    fleet_size_max: 44,
    bottom_25_percent: 0.441860465,
    median: 1.024390244,
    top_25_percent: 1.785714286,
    bottom_25_percent_base: 18.42424242,
    median_base: 40.3030303,
    top_25_percent_base: 69.29411765,
  },
  {
    fleet_size_label: '45-55',
    fleet_size_min: 45,
    fleet_size_max: 55,
    bottom_25_percent: 0.46,
    median: 1,
    top_25_percent: 1.78,
    bottom_25_percent_base: 19.44186047,
    median_base: 45.07317073,
    top_25_percent_base: 78.57142857,
  },
  {
    fleet_size_label: '56-75',
    fleet_size_min: 56,
    fleet_size_max: 75,
    bottom_25_percent: 0.457627119,
    median: 1.014285714,
    top_25_percent: 1.742424242,
    bottom_25_percent_base: 25.3,
    median_base: 55,
    top_25_percent_base: 97.9,
  },
  {
    fleet_size_label: '76-100',
    fleet_size_min: 76,
    fleet_size_max: 100,
    bottom_25_percent: 0.434343434,
    median: 0.987654321,
    top_25_percent: 1.629213483,
    bottom_25_percent_base: 34.3220339,
    median_base: 76.07142857,
    top_25_percent_base: 130.6818182,
  },
  {
    fleet_size_label: '101-200',
    fleet_size_min: 101,
    fleet_size_max: 200,
    bottom_25_percent: 0.438095238,
    median: 0.962616822,
    top_25_percent: 1.540540541,
    bottom_25_percent_base: 43.43434343,
    median_base: 98.7654321,
    top_25_percent_base: 162.9213483,
  },
  {
    fleet_size_label: '201-300',
    fleet_size_min: 201,
    fleet_size_max: 300,
    bottom_25_percent: 0.398104265,
    median: 0.849498328,
    top_25_percent: 1.443636364,
    bottom_25_percent_base: 87.61904762,
    median_base: 192.5233645,
    top_25_percent_base: 308.1081081,
  },
  {
    fleet_size_label: '301-400',
    fleet_size_min: 301,
    fleet_size_max: 400,
    bottom_25_percent: 0.323684211,
    median: 0.795389049,
    top_25_percent: 1.220779221,
    bottom_25_percent_base: 119.4312796,
    median_base: 254.8494983,
    top_25_percent_base: 433.0909091,
  },
  {
    fleet_size_label: '401-550',
    fleet_size_min: 401,
    fleet_size_max: 550,
    bottom_25_percent: 0.320627803,
    median: 0.795698925,
    top_25_percent: 1.250574713,
    bottom_25_percent_base: 129.4736842,
    median_base: 318.1556196,
    top_25_percent_base: 488.3116883,
  },
  {
    fleet_size_label: '551-999',
    fleet_size_min: 551,
    fleet_size_max: 999,
    bottom_25_percent: 0.19803198,
    median: 0.721769499,
    top_25_percent: 1.161118509,
    bottom_25_percent_base: 176.3452915,
    median_base: 437.6344086,
    top_25_percent_base: 687.816092,
  },
  {
    fleet_size_label: '1000-2000',
    fleet_size_min: 1000,
    fleet_size_max: 2000,
    bottom_25_percent: 0.234476367,
    median: 0.526059764,
    top_25_percent: 1.054307116,
    bottom_25_percent_base: 197.8339483,
    median_base: 721.0477299,
    top_25_percent_base: 1159.95739,
  },
  {
    fleet_size_label: '2001-3000',
    fleet_size_min: 2001,
    fleet_size_max: 3000,
    bottom_25_percent: 0.230095873,
    median: 0.546184739,
    top_25_percent: 0.92,
    bottom_25_percent_base: 468.952734,
    median_base: 1052.119527,
    top_25_percent_base: 2108.614232,
  },
  {
    fleet_size_label: '3001-4000',
    fleet_size_min: 3001,
    fleet_size_max: 4000,
    bottom_25_percent: 0.201869159,
    median: 0.68230694,
    top_25_percent: 1.183477107,
    bottom_25_percent_base: 690.2876198,
    median_base: 1638.554217,
    top_25_percent_base: 2760,
  },
  {
    fleet_size_label: '4001-5000',
    fleet_size_min: 4001,
    fleet_size_max: 5000,
    bottom_25_percent: 0.39155348,
    median: 0.565131579,
    top_25_percent: 1.03215169,
    bottom_25_percent_base: 807.4766355,
    median_base: 2729.227761,
    top_25_percent_base: 4733.908427,
  },
  {
    fleet_size_label: '5000-99999',
    fleet_size_min: 5000,
    fleet_size_max: 99999,
    bottom_25_percent: 0.043552036,
    median: 0.314428336,
    top_25_percent: 0.852766347,
    bottom_25_percent_base: 1957.767402,
    median_base: 2825.657895,
    top_25_percent_base: 5160.75845,
  },
];
